<div class="usermenu" data-id="usermenu">
  <button class="usermenu__trigger" data-id="usermenu-trigger" type="button" aria-haspopup="true" aria-expanded="false">
    <span class="avatar"><%= user.initials %></span>
    <span class="usermenu__id">
      <span class="usermenu__name"><%= user.name %></span>
      <span class="usermenu__role"><%= user.role %></span>
    </span>
    <span class="usermenu__chevron"><i class="icon icon--chevron-down"></i></span>
  </button>

  <div class="usermenu__dropdown" role="menu">
    <div class="usermenu__header">
      <div class="nm"><%= user.name %></div>
      <div class="em"><%= user.email %></div>
    </div>
    <a class="menu-item" href="#" data-id="profile" role="menuitem">
      <i class="icon icon--user"></i> <%= _lcs( 'Mein Profil' ) %>
    </a>
    <a class="menu-item" href="#" data-id="settings" role="menuitem">
      <i class="icon icon--settings"></i> <%= _lcs( 'Einstellungen' ) %>
    </a>
    <!--
    <a class="menu-item" href="#" role="menuitem">
      <i class="icon icon--shield"></i> <%= _lcs( 'Sicherheit' ) %>
    </a>
    -->

    <div class="menu-sep"></div>

    <div class="usermenu__langs" role="group" aria-label="<%= _lcs( 'Sprache' ) %>">
      <span class="usermenu__langs-title"><i class="icon icon--languages"></i> <%= _lcs( 'Sprache' ) %></span>
      <div class="usermenu__langs-options">
        <% languages.forEach( function( lang ) { %>
        <button type="button" role="menuitemradio" data-id="lang" data-lang="<%= lang.code %>"
                aria-checked="<%= lang.code === currentLanguage ? 'true' : 'false' %>"
                class="usermenu__lang<%= lang.code === currentLanguage ? ' usermenu__lang--active' : '' %>"><%= lang.label %></button>
        <% } ); %>
      </div>
    </div>

    <div class="menu-sep"></div>
    <a class="menu-item menu-item--danger" href="#" data-id="logout" role="menuitem">
      <i class="icon icon--log-out"></i> <%= _lcs( 'Abmelden' ) %>
    </a>
  </div>
</div>
